import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_CONTRACTORS = "fetchContractors";
export const FETCH_CONTRACTOR = "fetchContractor";
export const SAVE_CONTRACTOR = "saveContractor";
export const UPDATE_CONTRACTOR = "updateContractor";
export const DELETE_CONTRACTOR = "deleteContractor";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingContractor";
export const SET_CONTRACTORS = "setContractors";

const state = {
  errors: [],
  contractors: [],
  isLoadingContractor: false
};

const getters = {
  isLoadingContractor() {
    return state.isLoadingContractor;
  },
  getContractors() {
    return state.contractors;
  }
};

const actions = {
  [FETCH_CONTRACTORS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("contractors" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_CONTRACTOR](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("contractors", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_CONTRACTOR](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("contractors", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_CONTRACTOR](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("contractors", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_CONTRACTOR](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("contractors", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingContractor = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingContractor = value;
  },
  [SET_CONTRACTORS](state, data) {
    state.isLoadingContractor = false;
    state.contractors = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};